import React, { useEffect, useMemo, useState } from "react";
import MasterService from "../services/master/MasterService";

const Bentuk = ({idBentuk}) => {

    let masterService = useMemo(() => new MasterService(), [])
    const [ketBentuk, setKetBentuk] = useState('')

    useEffect(() => {
        const getBentuk = async () => {
            const response = await masterService.getBentukIkanById(idBentuk)
            // console.log(response)
            setKetBentuk(response.data.ketBentuk)
        }
        getBentuk()
    }, [masterService, idBentuk])

    return (
        <>
            <div>{ketBentuk}</div>
        </>
    )
}

export default Bentuk